import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface UiPreferencesState {
  hideMoney: boolean;
  setHideMoney: (hidden: boolean) => void;
  toggleHideMoney: () => void;
}

const safeStorage: {
  getItem: (name: string) => string | null;
  setItem: (name: string, value: string) => void;
  removeItem: (name: string) => void;
} = {
  getItem: (name) => {
    try {
      if (typeof localStorage === 'undefined') return null;
      return localStorage.getItem(name);
    } catch {
      return null;
    }
  },
  setItem: (name, value) => {
    try {
      if (typeof localStorage === 'undefined') return;
      localStorage.setItem(name, value);
    } catch {
      /* modo privado / quota */
    }
  },
  removeItem: (name) => {
    try {
      if (typeof localStorage === 'undefined') return;
      localStorage.removeItem(name);
    } catch {
      /* ignore */
    }
  },
};

export const useUiPreferences = create<UiPreferencesState>()(
  persist(
    (set, get) => ({
      hideMoney: false,
      setHideMoney: (hidden) => set({ hideMoney: hidden }),
      toggleHideMoney: () => set({ hideMoney: !get().hideMoney }),
    }),
    {
      name: 'valiosascrm-ui-prefs',
      storage: createJSONStorage(() => safeStorage),
    },
  ),
);
